<div class="modal-header">
  <h3 class="modal-title">{{data.HeadingText}}</h3>
  <button class="fa fa-times" [mat-dialog-close]="" style="float: right;cursor: pointer;background: none;border:none"
    aria-hidden="true"></button>
</div>
<div class="modal-body modal-body-height">
  <div class="mb-2 fg-g-red" *ngIf="!isAllow">
    <h3>Maximum library limit reached.</h3>
  </div>
  <div class="mb-2 fg-g-red" *ngIf="isExist">
    <h3>Library name already exist.</h3>
  </div>
  <div class="row" *ngIf="data.IsAction">
    <div class="col-lg-4">
      <div class="form-group">
        <label class="control-label fw f-16">Geography</label>
        <mat-chip-grid #geographyList>
          <ng-container *ngFor="let geography of regulationFilter.geography">
            <mat-chip-row [selectable]="selectable" [removable]="removable" (removed)="removeGeography(geography)">
              {{geography}}
              <mat-icon matChipRemove *ngIf="removable">x</mat-icon>
            </mat-chip-row>
          </ng-container>
          <input class="form-control form-control-sm mat-autodd-input border-bottom" #geographyInput
            [formControl]="searchGeographyCntrl" [matAutocomplete]="geographyAutoComplete"
            [matChipInputFor]="geographyList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
            [matChipInputAddOnBlur]="addOnBlur" (matChipInputTokenEnd)="addGeography($event)">
        </mat-chip-grid>
        <mat-autocomplete #geographyAutoComplete="matAutocomplete" (optionSelected)="selectedGeographyEvent($event)">
          <mat-option *ngFor="let item of searchedGeographies" [value]="item.value">
            {{item.name}}
          </mat-option>
        </mat-autocomplete>
      </div>
    </div>
    <div class="col-lg-4">
      <div class="form-group">
        <label class="control-label fw f-16">Country</label>
        <mat-chip-grid #countryList>
          <ng-container *ngFor="let country of regulationFilter.country">
            <mat-chip-row [selectable]="selectable" [removable]="removable" (removed)="removeCountry(country)">
              {{country}}
              <mat-icon matChipRemove *ngIf="removable">x</mat-icon>
            </mat-chip-row>
          </ng-container>
          <input class="form-control form-control-sm mat-autodd-input border-bottom" #countryInput
            [formControl]="searchCountryCntrl" [matAutocomplete]="countryAutoComplete"
            [matChipInputFor]="countryList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
            [matChipInputAddOnBlur]="addOnBlur" (matChipInputTokenEnd)="addCountry($event)">
        </mat-chip-grid>
        <mat-autocomplete #countryAutoComplete="matAutocomplete" (optionSelected)="selectedCountryEvent($event)">
          <mat-option *ngFor="let item of searchedCountries" [value]="item.value">
            {{item.name}}
          </mat-option>
        </mat-autocomplete>
      </div>
    </div>
    <div class="col-lg-4">
      <div class="form-group">
        <label class="control-label fw f-16">Regulator</label>
        <mat-chip-grid #regulatorList>
          <ng-container *ngFor="let regulator of regulationFilter.regulator">
            <mat-chip-row [selectable]="selectable" [removable]="removable" (removed)="removeRegulator(regulator)">
              {{regulator}}
              <mat-icon matChipRemove *ngIf="removable">x</mat-icon>
            </mat-chip-row>
          </ng-container>
          <input class="form-control form-control-sm mat-autodd-input border-bottom" #regulatorInput
            [formControl]="searchRegulatorCntrl" [matAutocomplete]="regulatorAutocomplete"
            [matChipInputFor]="regulatorList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
            [matChipInputAddOnBlur]="addOnBlur" (matChipInputTokenEnd)="addRegulator($event)">
        </mat-chip-grid>
        <mat-autocomplete #regulatorAutocomplete="matAutocomplete" (optionSelected)="selectedRegulatorEvent($event)">
          <mat-option *ngFor="let regulator of searchedRegulators" [value]="regulator.value">
            {{regulator.name}}
          </mat-option>
        </mat-autocomplete>
      </div>
    </div>
    <div class="col-lg-4">
      <div class="form-group">
        <label class="control-label fw f-16">Type</label>
        <mat-chip-grid #typeList>
          <mat-chip-row *ngFor="let type of regulationFilter.pubType" [selectable]="selectable" [removable]="removable"
            (removed)="removeType(type)">
            {{type}}
            <mat-icon matChipRemove *ngIf="removable">x</mat-icon>
          </mat-chip-row>
          <input class="form-control form-control-sm border-bottom" id="type" autocomplete="off"
            [matChipInputFor]="typeList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
            [matChipInputAddOnBlur]="addOnBlur" (matChipInputTokenEnd)="addType($event)">
        </mat-chip-grid>
      </div>
    </div>
    <div class="col-lg-4">
      <div class="form-group">
        <label class="control-label fw f-16">Topic</label>
        <mat-chip-grid #topicList>
          <mat-chip-row *ngFor="let topic of regulationFilter.ruleTopic" [selectable]="selectable" [removable]="removable"
            (removed)="removeTopic(topic)">
            {{topic}}
            <mat-icon matChipRemove *ngIf="removable">x</mat-icon>
          </mat-chip-row>
          <input class="form-control form-control-sm border-bottom" id="topic" autocomplete="off"
            [matChipInputFor]="topicList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
            [matChipInputAddOnBlur]="addOnBlur" (matChipInputTokenEnd)="addTopic($event)">
        </mat-chip-grid>
      </div>
    </div>
    <div class="col-lg-4">
      <div class="form-group">
        <label class="control-label fw f-16">Title</label>
        <mat-chip-grid #titleList>
          <mat-chip-row *ngFor="let item of regulationFilter.title" [selectable]="selectable" [removable]="removable"
            (removed)="removeTitle(item)">
            {{item}}
            <mat-icon matChipRemove *ngIf="removable">x</mat-icon>
          </mat-chip-row>
          <input class="form-control form-control-sm border-bottom" id="title" autocomplete="off"
            [matChipInputFor]="titleList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
            [matChipInputAddOnBlur]="addOnBlur" (matChipInputTokenEnd)="addTitle($event)">
        </mat-chip-grid>
      </div>
    </div>
    <div class="col-lg-4">
      <div class="form-group">
        <label class="control-label fw f-16">Key Words</label>
        <mat-chip-grid #keywordsList>
          <mat-chip-row *ngFor="let sQuery of regulationFilter.SearchQuery" [selectable]="selectable" [removable]="removable"
          (removed)="remove(sQuery)">
          {{sQuery}}
          <mat-icon matChipRemove *ngIf="removable">x</mat-icon>
        </mat-chip-row>
        <input class="form-control form-control-sm mat-autodd-input border-bottom" #keywordInput [formControl]="keyCtrl"
          [matAutocomplete]="autoKeyword" [matChipInputFor]="keywordsList"
          [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur"
          (matChipInputTokenEnd)="add($event)">
        </mat-chip-grid>
        <mat-autocomplete #autoKeyword="matAutocomplete" (optionSelected)="selected($event)">
          <mat-option *ngFor="let fK of filteredKeywords | async" [value]="fK">
            {{fK}}
          </mat-option>
        </mat-autocomplete>
      </div>
    </div>
    <div class="col-lg-4">
      <div class="form-group">
        <label class="control-label fw f-16">Topic (Negative Filter)</label>
        <mat-chip-grid #topicNegativeFilterList>
          <mat-chip-row *ngFor="let item of regulationFilter.topicNegativeFilter" [selectable]="selectable" [removable]="removable"
            (removed)="removeTopicNegativeFilter(item)">
            {{item}}
            <mat-icon matChipRemove *ngIf="removable">clear</mat-icon>
          </mat-chip-row>
          <input class="form-control form-control-sm border-bottom" id="title" autocomplete="off"
            [matChipInputFor]="topicNegativeFilterList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
            [matChipInputAddOnBlur]="addOnBlur" (matChipInputTokenEnd)="addTopicNegativeFilter($event)">
        </mat-chip-grid>
      </div>
    </div>
    <div class="col-lg-4">
      <div class="form-group">
        <label class="control-label fw f-16">Title (Negative Filter)</label>
        <mat-chip-grid #titleNegativeFilterList>
          <mat-chip-row *ngFor="let item of regulationFilter.titleNegativeFilter" [selectable]="selectable" [removable]="removable"
            (removed)="removeTitleNegativeFilter(item)">
            {{item}}
            <mat-icon matChipRemove *ngIf="removable">clear</mat-icon>
          </mat-chip-row>
          <input class="form-control form-control-sm border-bottom" id="title" autocomplete="off"
            [matChipInputFor]="titleNegativeFilterList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
            [matChipInputAddOnBlur]="addOnBlur" (matChipInputTokenEnd)="addTitleNegativeFilter($event)">
        </mat-chip-grid>
      </div>
    </div>
  </div>
  <!-- <div class="row" *ngIf="data.IsAction">
    <div class="col-md-12">
      <div class="form-group">
        <label class="control-label fw f-16">Title</label>
        <mat-chip-grid #titleList>
          <mat-chip-row *ngFor="let item of regulationFilter.title" [selectable]="selectable" [removable]="removable"
            (removed)="removeTitle(item)">
            {{item}}
            <mat-icon matChipRemove *ngIf="removable">x</mat-icon>
          </mat-chip-row>
          <input class="form-control form-control-sm border-bottom" id="title" autocomplete="off"
            [matChipInputFor]="titleList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
            [matChipInputAddOnBlur]="addOnBlur" (matChipInputTokenEnd)="addTitle($event)">
        </mat-chip-grid>
      </div>
    </div>
  </div> -->
  <div class="row">
    <div class="col-lg-6">
      <div class="form-group">
        <label class="control-label fw f-16">{{data.BodyText}}</label>
        <input type="text" class="form-control form-control-sm" disabled *ngIf="isInputDisabled" />
        <input type="text" class="form-control form-control-sm" *ngIf="!isInputDisabled"
          [(ngModel)]="existingLibrary.libraryName" />
        <div class="mt-2 fg-g-red">
          <small *ngIf="isWarningShow">Please enter {{data.BodyText}}</small>
        </div>
      </div>
    </div>
    <div class="col-lg-4">
      <div class="form-group" *ngIf="regulationLibrary && regulationLibrary.length > 0">
        <label class="control-label fw f-16">Existing Library</label>
        <div class="input-group input-group-sm">
          <select class="form-control form-control-sm" [(ngModel)]="existingId" (change)="getFilterJson()"
            [attr.disabled]="isSelectDisabled ? 'disabled': null">
            <option value="{{0}}">Select</option>
            <ng-container *ngFor="let item of regulationLibrary">
              <option *ngIf="item.libraryType === libraryType" value="{{item.id}}">
                <span [attr.class]="getIconClass(item.libraryType)"></span> {{ item.libraryName }}
                <span *ngIf="!item.isActive"> (H)</span>
              </option>
            </ng-container>
          </select>
          <div class="input-group-btn" *ngIf="existingId > 0">
            <button class="btn btn-sm btn-danger" (click)="deleteLibrary()">
              <i class="fa fa-trash"></i>
              <i *ngIf="isDeleteLoader" class="fa fa-circle-o-notch fa-spin"
                style="font-size: .875rem; line-height: 1.5;"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-2">
      <div class="form-group">
        <div class="left inline control-label mt-4 fw f-16" *ngIf="!isSelectDisabled">
          <i class="fa fa-square-o icon-font" (click)="libraryData.isHide = true" *ngIf="!libraryData.isHide"
            aria-hidden="true"></i>
          <i class="fa fa-check-square icon-font" (click)="libraryData.isHide = false" *ngIf="libraryData.isHide"
            aria-hidden="true"></i>
          Hide Library
        </div>
        <div class="left inline control-label mt-4 fw f-16" *ngIf="isSelectDisabled">
          <i class="fa fa-square-o icon-font" aria-hidden="true"></i>
          Hide Library
        </div>
      </div>
    </div>
  </div>
  <div class="row" *ngIf="isAddRulebookShow">
    <div class="col-lg-10" *ngIf="!libraryData.isRulebook"></div>
    <div class="col-lg-10" *ngIf="libraryData.isRulebook">
      <div class="form-group">
        <label class="control-label fw f-16">Rulebook</label>
        <ng-select *ngIf="searchedRulebooks.length > 0" class="regulation-dialog" [items]="searchedRulebooks" bindLabel="name" [multiple]="true"
          [(ngModel)]="selectedRulebooks">
        </ng-select>
      </div>
    </div>
    <div class="col-lg-2">
      <div class="form-group">
        <div class="left inline control-label mt-4 fw f-16">
          <i class="fa fa-square-o icon-font" (click)="disabledItem(true)" *ngIf="!libraryData.isRulebook"
            aria-hidden="true"></i>
          <i class="fa fa-check-square icon-font" (click)="disabledItem(false)" *ngIf="libraryData.isRulebook"
            aria-hidden="true"></i>
          Add to Rulebook 
        </div>
      </div>
    </div>
  </div>
</div>
<div class="modal-footer" *ngIf="isAllow">
  <button class="btn btn-sm bg-g-red" [mat-dialog-close]="">Cancel</button>
  <button class="btn btn-sm bg-g-lightGreen" (click)="onClickSave()"
    cdkFocusInitial>{{data.ActionButtonText}}</button>
</div>
